const config = {
  environment: process.env.NODE_ENV || 'dev',
  apiServer: {
    port: process.env.API_PORT || 8080,
    host: process.env.HOST || 'localhost'
  },
  server: {
    port: process.env.NGINX_API_PORT || 8080
  },
  socketserver: {
    url: process.env.UI_SOCKET_SERVER_URL || 'http://localhost'
    // url: process.env.SOCKET_SERVER_URL || 'http://40.76.80.83'
  },
  mongo: {
    url: process.env.MONGO_DB_URI || 'mongodb://localhost/radiantsrt'
  },
  logging: {
    dir: process.env.LOGSDIR || "logs",
    level:  process.env.LOGLEVEL || "debug"
  },
  docker: {
    socket: process.env.DOCKER_SOCKET || '/var/run/docker.sock',
    volume: process.env.DOCKER_VOLUME || '/var/www/vividcoredash/media/',
    backups: process.env.DOCKER_BACKUPS || '/home/radiant/backups/'
  },
  shaka: {
    enableDASH: true,
    utcTimingScheme: process.env.SHAKA_UTC_TIMING_SCHEME || 'urn:mpeg:dash:utc:http-head:2014',
    utcTimingValue: process.env.SHAKA_UTC_TIMING_VALUE || 'http://192.168.2.117/media/time.txt'
  },
  nginx: {
    // configPath: process.env.NGINX_CONFIG_PATH || "/usr/local/etc/nginx/nginx.conf"
    configPath: process.env.NGINX_CONFIG_PATH || "/etc/nginx/sites-available/default"
  },
  qam: {
    defaultInterface : 'enp6s0'
  },
  demo: {
    mode: "off",
    streamTimeout: 1 //minutes
  },
  licenses: {
    count: 10,
    enableTSStats: true,
    enableVideoPreview: true,
    enableQam: true
  },
  app: {
    version: "2.7.6.0"
  }
}

module.exports = config;
// export default config;
